<template>
  <div class="flex mb-12 exercise-form">
    <div class="w-3/5 content-left-panel">
      <exercise-form-content 
        :embedded="false"
        :onClick="saveExercise"
      />
    </div>
    <div class="w-2/5 pl-10 content-right-panel">
      <div class="flex mb-10 -mx-2" v-if="isEditing">
        <div class="w-1/2 mx-2 modified-date">
          <label class="vs-input--label">Modified on</label>
          <vs-input disabled :value="getCurrentExercise.modified | dateFormat"></vs-input>
        </div>
        <div class="w-1/2 mx-2 created-date">
          <label class="vs-input--label">Created on</label>
          <vs-input disabled :value="getCurrentExercise.created | dateFormat"></vs-input>
        </div>
      </div>
      <div class="flex -mx-2 action-buttons" v-sticky sticky-offset="{top: 25}">
        <vs-button class="w-full mx-2" color="primary" icon-pack="feather" @click="saveExercise">Save</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Sticky from 'vue-sticky-directive'
import exerciseFormContent from './forms/exercises/ExerciseFormContent'

export default {
  components: {
    exerciseFormContent
  },
  directives: {Sticky},
  async created() {
    if (this.$route && this.$route.params.id) {
      if (this.$route.params.id !== this.getCurrentExercise.id) {
        this.getExerciseToEdit(this.$route.params.id)
      }
    } else {
      this.resetCurrentExercise()
    }
  },
  computed: {
    ...mapGetters('app', ['getSelectedCompanyName']),
    ...mapGetters('exercises', ['getCurrentExercise']),
    isEditing () {
      return this.$route.name === 'edit-exercise'
    }
  },
  methods: {
    ...mapActions('exercises', ['getExerciseAction', 'resetCurrentExercise', 'saveExerciseToApi']),
    async saveExercise () {
      try {
        this.$vs.loading()
        
        const response = await this.saveExerciseToApi()

        if (this.$route.name === 'create-exercise') {
          this.$router.push({name: 'edit-exercise', params: {id: response.id}})
        }

        this.$vs.notify({
          title: "Success",
          text: 'Exercise saved',
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success"
        })
      } catch (error) {
        this.showError(error)
      }
      this.$vs.loading.close()
    },
    async getExerciseToEdit(exerciseId) {
      try {
        this.$vs.loading();
        await this.getExerciseAction({exerciseId: exerciseId})
        this.$vs.loading.close();
      } catch (error) {
        this.showError(error)
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "create-exercise") {
      this.resetCurrentExercise();
    }
    if (to.name === 'edit-exercise') {
      this.getExerciseToEdit(to.params.id)
    }
    next();
  }
}
</script>
<style lang="scss" scoped>

</style>